export class JobStatusFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<JobStatus>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<JobStatus>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobStatusFilters.attributeTypeMap;
    }
    constructor() {
    }
}
